import apiClient from "./client";
import type { LicenseFeature, ApiResponse, ListResponse } from "@/types";

const BASE = "/features";

export interface FeatureQueryParams {
  page?: number;
  page_size?: number;
  search?: string;
  logic?: "and" | "or";
  id?: number;
  feature_key?: string;
  label?: string;
  data_type?: string;
  is_system?: boolean;
  created_at_start?: string;
  created_at_end?: string;
}

export async function listFeatures(
  params?: FeatureQueryParams,
): Promise<ApiResponse<ListResponse<LicenseFeature>>> {
  const { data } = await apiClient.get(BASE, { params });
  return data;
}

export async function createFeature(feature: {
  feature_key: string;
  feature_label: string;
  data_type: string;
  description?: string;
}): Promise<ApiResponse<LicenseFeature>> {
  const { data } = await apiClient.post(BASE, feature);
  return data;
}

export async function getFeatureByKey(
  key: string,
): Promise<ApiResponse<LicenseFeature>> {
  const { data } = await apiClient.get(
    `${BASE}/key/${encodeURIComponent(key)}`,
  );
  return data;
}

export async function getFeatureById(
  id: number,
): Promise<ApiResponse<LicenseFeature>> {
  const { data } = await apiClient.get(`${BASE}/${id}`);
  return data;
}

export async function updateFeature(
  id: number,
  feature: {
    feature_key?: string;
    feature_label?: string;
    data_type?: string;
    description?: string;
  },
): Promise<ApiResponse<LicenseFeature>> {
  const { data } = await apiClient.put(`${BASE}/${id}`, feature);
  return data;
}

export async function updateFeaturesBatch(data: {
  ids: number[];
  feature_label?: string;
  data_type?: string;
  description?: string;
}): Promise<ApiResponse<null>> {
  const res = await apiClient.patch(BASE, data);
  return res.data;
}

export async function deleteFeaturesBatch(data: {
  ids: number[];
}): Promise<ApiResponse<null>> {
  const res = await apiClient.delete(BASE, { data });
  return res.data;
}

export async function deleteFeature(id: number): Promise<ApiResponse<null>> {
  const { data } = await apiClient.delete(`${BASE}/${id}`);
  return data;
}
